<!-- 航班详情（移动运行网扫码）-->
<template>
  <div class="backgroundGrey base-padding">
    <div class="details-card">
      <div class="details-title">
        航班信息
      </div>
      <div class="detailsItem">
        <div>
          <span>航班日期：</span>
          <span>{{ main.flightDateDesc }}</span>
        </div>
        <div>
          <span>航班环：</span>
          <span>{{ main.flightNoRing }}</span>
        </div>
        <div>
          <span>航段环：</span>
          <span>{{ main.flightLineRing }}</span>
        </div>
        <div>
          <span>配出铅封号：</span>
          <span>{{ main.distributeSealNo }}</span>
        </div>
        <div>
          <span>销售车号：</span>
          <span>{{ main.sellPackageNo }}</span>
        </div>
        <div>
          <span>配发销售车数量：</span>
          <span>{{ main.distributePackageCount }}</span>
        </div>
        <div v-if="main.state === 3">
          <span>领取销售车数量：</span>
          <span>{{ main.receiveSellPackageCount }}</span>
        </div>
        <div v-if="[3,4,5].includes(main.state)">
          <span>领取人：</span>
          <span>{{ main.receiveStaffName }}</span>
        </div>
        <div v-if="[3,4,5].includes(main.state)">
          <span>领取时间：</span>
          <span>{{ main.receiveTime }}</span>
        </div>
        <div v-if="[4,5].includes(main.state)">
          <span>归还人：</span>
          <span>{{ main.returnStaffName }}</span>
        </div>
        <div v-if="[4,5].includes(main.state)">
          <span>归还时间：</span>
          <span>{{ main.returnTime }}</span>
        </div>
        <div>
          <span>状态：</span>
          <span>{{ main.stateDesc }}</span>
        </div>
      </div>
    </div>
    <div class="details-card" style="padding: 0;">
      <div class="sp-title" >商品清单</div><span style="color: red" @click="show">{{ isShow ? '折叠' : '展开' }}</span>
      <div v-if="isShow">
        <Grid :columns="columns" :tableData="main.bagProductSignList" style="margin: 0 1rem;" />
      </div>

    </div>
    <!-- 领取销售车数量 -->
    <div class="details-card" style="padding: 0" v-if="main.state === 2">
      <van-form>
        <van-field v-model="main.receiveSellPackageCount" colon required label-width="120px" input-align="right" name="领取销售车数量" type="digit" label="领取销售车数量"
                   placeholder="请输入数量" />
      </van-form>
    </div>
    <!-- 回收铅封号 -->
    <div class="details-card" style="padding: 0" v-if="main.state === 3">
      <van-form>
        <van-field v-model="main.recoverySealNo" colon required label-width="120px" input-align="right" name="回收铅封号" label="回收铅封号" placeholder="请输入回收铅封号" />
      </van-form>
    </div>
    <!-- 归还销售车数量 -->
    <div class="details-card" style="padding: 0" v-if="main.state === 3">
      <van-form>
        <van-field v-model="main.returnSellPackageCount" colon required label-width="120px" input-align="right" name="归还销售车数量" type="digit" label="归还销售车数量"
                   placeholder="请输入归还销售车数量" />
      </van-form>
    </div>
    <div class="details-card">
      <div style="font-size: 14px;line-height: 40px;">上传图片</div>
      <Upload ref="Upload" />
    </div>
    <div class="details-card" style="padding: 0">
      <van-field v-model="remark" type="textarea" placeholder="请输入备注说明：" show-word-limit :maxlength="100" autosize label-width="0" />
    </div>
    <BottomButton>
      <van-button type="primary" @click="confirm">{{ main.state === 2 ? '确认' : '归还' }}</van-button>
      <van-button type="primary" v-if="main.state === 2" @click="invalid">未上机</van-button>
    </BottomButton>
  </div>

</template>

<script>
import EmptyTips from '@/components/common/EmptyTips'
import Grid from '@/components/common/Grid/index.vue'
import BottomButton from '@/components/common/BottomButton'
import Upload from '@/components/common/Upload.vue'

export default {
  components: {
    EmptyTips,
    Grid,
    BottomButton,
    Upload,
  },
  data() {
    return {
      detailsId: '',
      main: {},
      username: '',
      applies: [],
      fileList: [],
      digit: '',
      remark: '',
      isShow:false,
    }
  },
  computed: {
    columns() {
      console.warn(88)
      console.warn(this.main.state)
      let arr = []
      // 已确认
      if ([1, 2].includes(this.main.state)) {
        arr = [
          { label: '商品名称', prop: 'productName' },
          { label: '单位', prop: 'basicUnitEnuName' },
          { label: '标配', prop: 'standardNum' },
          { label: '实配', prop: 'actualNum', type: 'number' },
        ]
      }
      // 已领取
      if ([3].includes(this.main.state)) {
        arr = [
          { label: '商品名称', prop: 'productName' },
          { label: '单位', prop: 'basicUnitEnuName' },
          { label: '标配', prop: 'standardNum' },
          { label: '实配', prop: 'actualNum' },
          { label: '回收', prop: 'recoveryNum', type: 'number' },
        ]
      }
      // 已归还
      if ([4].includes(this.main.state)) {
        arr = [
          { label: '商品名称', prop: 'productName', width: 80 },
          { label: '单位', prop: 'basicUnitEnuName' },
          { label: '标配', prop: 'standardNum' },
          { label: '实配', prop: 'actualNum' },
          { label: '回收', prop: 'recoveryNum' },
        ]
      }
      // 已完成
      if ([5].includes(this.main.state)) {
        arr = [
          { label: '商品名称', prop: 'productName', width: 80 },
          { label: '单位', prop: 'basicUnitEnuName' },
          { label: '标配', prop: 'standardNum' },
          { label: '实配', prop: 'actualNum' },
          { label: '回收', prop: 'recoveryNum' },
          { label: '实收', prop: 'actualRecoveryNum' },
        ]
      }
      return arr
    },
  },
  activated() {
    this.detailsId = this.$route.query.id
    this.remark = ''
    this.getDetails()
    this.$refs.Upload.clear()
  },
  methods: {
    getDetails() {
      let _this = this
      this.$api.get('/api-sys/apiStaffOverNightBag/getById?id=' + this.detailsId).then((res) => {
        if (res.code === '0000') {
          _this.main = res.data
          if (_this.main.state === 2) {
            _this.main.bagProductSignList.forEach((item) => {
              item.actualNum = item.standardNum
            })
          }
          if (_this.main.state === 3) {
            _this.main.bagProductSignList.forEach((item) => {
              item.recoveryNum = item.actualNum
            })
          }
          if (_this.main.state === 2) {
            _this.main.receiveSellPackageCount = _this.main.distributePackageCount
          }
          if (_this.main.state === 3) {
            _this.main.returnSellPackageCount = _this.main.receiveSellPackageCount
          }
        }
      })
    },
    confirm() {
      if (this.main.state === 2) {
        this.receive()
      } else {
        this.restitution()
      }
    },
    // 领取
    receive() {
      if (!this.main.receiveSellPackageCount) {
        this.$Toast('请输入领取销售车数量！')
        return
      }
      let _this = this
      this.$Dialog
        .confirm({
          title: '标题',
          message: '请确认配出铅封号是否一致，销售车数量是否正确？',
          messageAlign: 'left',
        })
        .then(() => {
          let params = {
            id: _this.detailsId,
            // staffId: 1000134488,
            staffId: this.$store.state.userInfo.userId,
            receiveSellPackageCount: _this.main.receiveSellPackageCount, // 领用销售车数量
            receiveRemark: _this.remark, // 领取备注
            imgUrlList: _this.$refs.Upload.getFiles(), // 领取图片列表
            bagProductSignList: _this.main.bagProductSignList, // 商品列表
          }
          this.$api.post('/api-sys/apiStaffOverNightBag/receiveBag', params).then((res) => {
            if (res.code === '0000') {
              this.$Toast.success('操作成功')
              setTimeout(() => {
                this.$utils.routerPush({
                  name: 'OvernightBag',
                })
              }, 700)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 归还
    restitution() {
      if (!this.main.recoverySealNo) {
        this.$Toast('请输入回收铅封号！')
        return
      }
      if (!this.main.returnSellPackageCount) {
        this.$Toast('请输入归还销售车数量！')
        return
      }
      let _this = this
      this.$Dialog
        .confirm({
          title: '标题',
          message: '是否确认归还？',
          messageAlign: 'left',
        })
        .then(() => {
          let params = {
            id: _this.detailsId,
            // staffId: 1000134488,
            staffId: this.$store.state.userInfo.userId,
            returnSellPackageCount: _this.main.returnSellPackageCount, // 归还销售车数量
            returnRemark: _this.remark, // 归还备注
            recoverySealNo: _this.main.recoverySealNo, // 回收铅封号
            imgUrlList: _this.$refs.Upload.getFiles(), // 归还图片列表
            bagProductSignList: _this.main.bagProductSignList, // 商品列表
          }
          this.$api.post('/api-sys/apiStaffOverNightBag/returnBag', params).then((res) => {
            if (res.code === '0000') {
              this.$Toast.success('操作成功')
              setTimeout(() => {
                this.$utils.routerPush({
                  name: 'OvernightBag',
                })
              }, 700)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 作废
    invalid() {
      let _this = this
      this.$Dialog
        .confirm({
          title: '标题',
          message: '是否确认作废？',
          messageAlign: 'left',
        })
        .then(() => {
          let params = {
            id: _this.detailsId,
          }
          this.$api.post('/api-sys/overnightBag/invalid', params).then((res) => {
            if (res.code === '0000') {
              this.$Toast.success('操作成功')
              setTimeout(() => {
                this.$utils.routerPush({
                  name: 'OvernightBag',
                })
              }, 700)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    show() {
      this.isShow = !this.isShow;
    }
  },
}
</script>

<style lang="less" scoped>
.detailsItem {
  width: 100%;
  background: white;

  & > div {
    span {
      min-width: 120px;
      // line-height: 30px;
    }
  }
}
.sp-title {
  border-left: 6px solid #e1514c;
  border-bottom: 2px solid #e1514c;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/OvernightBag/OvernightCarDetails.vue